import { MolsonBox } from '@components/reusable'
import { molsonUseTheme } from '@theme'

export type BrandCardType = {
  brand: string
  logo: string
  onClick?: () => void
  selected?: boolean
}

export const BrandCard = ({
  brand,
  logo,
  onClick,
  selected = false
}: BrandCardType) => {
  const theme = molsonUseTheme()
  return (
    <MolsonBox
      boxShadowType={
        selected ? 'primaryLightBoldSelected' : 'defaultBoldUnselected'
      }
      sx={{
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        height: 134,
        overflow: 'hidden',
        backgroundColor: `${theme.palette.secondary[50]}`
      }}
      borderRadiusType="defaultRounded"
      dataTestId="brand-card"
      onClick={onClick}
    >
      <img
        style={{
          margin: '0 auto',
          maxWidth: '65%'
        }}
        alt={brand}
        src={logo}
      />
    </MolsonBox>
  )
}
